import { createPdf } from '@/vendor/pdfMake';

const chunkArray = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

const formatForPdf = value => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number' && isFinite(value)) {
    const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    return String(rounded);
  }
  return String(value);
};

const buildBody = (list, selectedColumns, data, scope) => {
  const header = selectedColumns.map(_ => _.title);
  const rows = [];
  list.forEach(_ => {
    if (_ && !_.separator) {
      const row = selectedColumns.map(column => {
        let value = column.lens(_, { data }, scope);
        if (value && typeof value === 'object') {
          const key = column.key;
          value = key in value ? value[key] : value.id;
        }
        const text = formatForPdf(value);
        return { text, noWrap: false };
      });
      rows.push(row);
    }
  });
  return [header, ...rows];
};

export default (
  list,
  columns,
  data,
  scope,
  options = { fileName: 'export.pdf', mode: 'print', freezeCols: 1, maxColsPerPage: 8 }
) => {
  const colCount = columns.length;
  const freeze = Math.max(0, Math.min(options.freezeCols ?? 1, colCount));
  const maxColsPerPage = Math.max(1, options.maxColsPerPage ?? 8);

  const frozenCols = columns.slice(0, freeze);
  const variableCols = columns.slice(freeze);
  const perPageVariable = Math.max(1, maxColsPerPage - freeze);
  const variableChunks =
    variableCols.length > perPageVariable ? chunkArray(variableCols, perPageVariable) : [variableCols];

  const columnPages = variableChunks.map(chunk => [...frozenCols, ...chunk]);

  const content = columnPages.map((cols, idx) => ({
    pageBreak: idx < columnPages.length - 1 ? 'after' : undefined,
    table: {
      headerRows: 1,
      dontBreakRows: true,
      keepWithHeaderRows: 1,
      widths: new Array(cols.length).fill('auto'),
      body: buildBody(list, cols, data, scope),
    },
    layout: 'lightHorizontalLines',
  }));

  const docDefinition = {
    pageOrientation: 'landscape',
    pageSize: 'A4',
    pageMargins: [20, 20, 20, 20],
    content,
    defaultStyle: { fontSize: 9 },
  };

  const pdf = createPdf(docDefinition);
  if (options.mode === 'download') {
    pdf.download(options.fileName || 'export.pdf');
  } else if (options.mode === 'open') {
    pdf.open();
  } else {
    pdf.print();
  }
};
